export default __webpack_public_path__ + "static/media/deleted.ba80b2bf.webp";